import { Component, OnInit, Injector }  from '@angular/core';
import UserSearch                       from '../../models/UserSearch';
import ObjectList                       from '../../models/ObjectList';
import ZimbraUser                             from '../../models/ZimbraUser';
import { PageableComponent } from '../../_components/PageableComponent';

@Component({
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.css']
})
export class UserManagerComponent extends PageableComponent implements OnInit {

  user_search       : UserSearch        = new UserSearch();
  users             : ObjectList<ZimbraUser>  = new ObjectList();
  plain_list        : ZimbraUser[]      = [];
  displayed_columns : String[]          = [ "username" , "first_name" , "last_name" , "email" , "zimbra_instance" , "actions"  ];

  constructor(  
    private injector              : Injector
  ) 
  { 
    super(injector);
    this.per_page = 20;
    this.setPageChangeCallback(this._getUsers);
    this.addOrdering("name","asc");
  }

  ngOnInit() 
  {
    this._getUsers();
  }

  search()
  {
    this._getUsers();
  }

  _getUsers()
  {
    this.loading = true;
    this._userService.getUsers(this.user_search , this.per_page , this.page_number).subscribe(
      data => {
        this.total_rows         = data["retdata"]["total"];
        this.loading            = false;
        this.users.clear();
        for (var current of data["retdata"]["data"])
        {
          this.users.push(new ZimbraUser(current) , "id");
        }
        this.plain_list = [];
        this.users.pour(this.plain_list);
        
        
        
      },
      err => {
        this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
    })
  }

  editUser(user_id)
  {
    this._router.navigate(['dashboard','admin','users','create',user_id]);
  }

  //************************* */
  deleteUser(user_id)
  {
    this._interfaceService.openConfirmDialog(function() { this._deleteUser(user_id); }.bind(this) , this._translateService.instant("users.delete_note"));
  }

  _deleteUser(user_id)
  {
    this._userService.deleteUser(user_id).subscribe(
      data => {
        var res                 = data["retdata"];
        this._interfaceService.openReturnSnackBar(data);
        this.ngOnInit();
      },
      error => {
        this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
      });
  }

}
